import { AnyAction, Dispatch } from 'redux';
import { setError } from 'state/Error';
import { ErrorType } from 'state/Error/types';
import { AppState } from 'state/reducer';
import { WidgetConfiguration } from 'state/Widget/types';

import { environment } from '../environments';

export const fetchCC = (
  path: string,
  configuration: WidgetConfiguration,
  options: Parameters<typeof fetch>[1] = {},
  api = environment.api
) => {
  const url = `${api.baseUrl}/${api.ccwc}/${api.version}/${path}`;
  const { headers = {}, ...otherOptions } = options;

  return fetch(url, {
    headers: {
      ...(configuration && {
        appKey: configuration.appKey,
        'Host-Referer': configuration.hostReferer,
      }),
      ...headers,
    },
    ...otherOptions,
  });
};

export const fetchWithState =
  (dispatch: Dispatch<AnyAction>, getState: () => AppState) =>
  (path: string, ...args) => {
    const { widgetConfiguration } = getState();
    return fetchCC(path, widgetConfiguration, ...args).then(
      res => {
        if (res.status >= 400) {
          dispatch(
            setError({
              type: ErrorType.NETWORK,
              message: `An error occured when calling: ${path}`,
            })
          );
          return null;
        } else {
          return res;
        }
      },
      () => {
        dispatch(
          setError({
            type: ErrorType.NETWORK,
            message: 'Problem establishing server connection',
          })
        );
        return null;
      }
    );
  };
